"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function RowChart(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "chart-bar flex-column flex-sm-row",
    children: props.data.map(function (entry, key) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "chart-bar-element reverted ".concat(entry.color),
        style: {
          width: "".concat(entry.percentage, "%")
        }
      }, key);
    })
  });
}

RowChart.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    percentage: _propTypes.default.number.isRequired,
    color: _propTypes.default.string.isRequired
  })).isRequired
};
var _default = RowChart;
exports.default = _default;
//# sourceMappingURL=RowChart.js.map